import { Seo } from '../components/Seo';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { incubatorData } from '../data/incubator';
import { Link } from 'react-router-dom';
import './Incubator.css';

const Incubator = () => {
  // Sort projects alphabetically by title just in case
  const sortedProjects = [...incubatorData].sort((a, b) => a.title.localeCompare(b.title));

  return (
    <>
      <Seo
        title="Incubator - Schwabe.net"
        description="Inventing and incubating new technologies, startups, and micro-SaaS opportunities."
        type="webapp"
      />
      <Header selectedNavitem="incubator" />

      <div className="incubator-hero text-center">
        <div className="container">
          <h1 className="display-4 fw-bold mb-3">Innovation & Incubation</h1>
          <div className="lead mx-auto">
            <p>
              We invent and incubate technologies ranging from new startups to micro-SaaS opportunities.
            </p>
            <p className="fs-7 text-muted">
              Projects listed here are open for collaboration. We are looking for entrepreneurial business people, teams, or investors interested in partnering to bring these projects to market.
            </p>
            <p className="fs-7 text-muted mb-0">
              <strong>Interested?</strong> We are happy to connect and discuss any of these opportunities.  Also contact us if you have a project you think we should consider getting involved with.
            </p>
          </div>
        </div>
      </div>

      <div className="container mb-5 pb-5">
        <div className="row g-4">
          {sortedProjects.map((project, index) => (
            <div key={index} className="col-lg-4 col-md-6 d-flex align-items-stretch">
              <div className="project-card w-100">
                <div className="project-img-wrapper">
                  <img src={project.img} alt={project.title} />
                </div>
                <div className="project-content">
                  <h3 className="h4">
                    <Link to={project.link} className="project-title d-block">
                      {project.title}
                    </Link>
                  </h3>
                  <p className="project-description">
                    {project.description}
                  </p>
                  <Link to={project.link} className="project-link mt-auto">
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  )
};

export default Incubator;